export default "__VITE_ASSET__DXP0hH2d__"